module.exports = __webpack_public_path__ + "static/media/fam_knol_header.2e1fda04.jpg";